import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers';
import {
  analyticsDataCollector,
  syncLocalStorage,
  fbAppEventsCollector,
  taboolaPixelListener,
  mixpanelDataCollector,
  // adformDataCollector,
  dengageAppEventsCollector,
} from './middlewares';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import reduxPersistTransform from 'Utils/reduxPersistTransform';
 
export const middleware = [
  thunk,
  syncLocalStorage,
  analyticsDataCollector,
  fbAppEventsCollector,
  taboolaPixelListener,
  mixpanelDataCollector,
  dengageAppEventsCollector,
  // adformDataCollector
];

let enhancer = applyMiddleware(...middleware);

if (process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION__) {

  enhancer = compose(
    applyMiddleware(...middleware),
    window.__REDUX_DEVTOOLS_EXTENSION__()
  );

}


const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'], // only auth will be persisted,
  transforms: [reduxPersistTransform]
};

const persistedReducer = persistReducer(persistConfig, reducers);


const store = createStore(
  persistedReducer,
  window.INITIAL_STATE || {},
  enhancer
);

// Allow the passed state to be garbage-collected
delete window.INITIAL_STATE;


let persistor = persistStore(store);

export {
  persistor
};

export default store;
